import { render, staticRenderFns } from "./EditionPlanAlimentaire.vue?vue&type=template&id=0822c5ec&scoped=true&"
import script from "./EditionPlanAlimentaire.vue?vue&type=script&lang=js&"
export * from "./EditionPlanAlimentaire.vue?vue&type=script&lang=js&"
import style0 from "./EditionPlanAlimentaire.vue?vue&type=style&index=0&id=0822c5ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0822c5ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0822c5ec')) {
      api.createRecord('0822c5ec', component.options)
    } else {
      api.reload('0822c5ec', component.options)
    }
    module.hot.accept("./EditionPlanAlimentaire.vue?vue&type=template&id=0822c5ec&scoped=true&", function () {
      api.rerender('0822c5ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Divers/EditionPlanAlimentaire.vue"
export default component.exports